var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMaterialShow)?_c('div',{staticClass:"meterial"},[_c('pptDetail',{attrs:{"url":_vm.pptUrl,"teacher":true,"defaultShowMeterial":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }